module.exports = __webpack_public_path__ + "img/20200613_093815.2f8edbdb.jpg";